export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/NewlyAddedAr.1262456f.svg","height":48,"width":70,"blurWidth":0,"blurHeight":0};